/**
 * Upload helpers for the dashboard.
 *
 * The uploader itself moved to `@rp/studio-client`, because Studio now uploads
 * the recording as soon as a session ends and the retry and resume rules must
 * have exactly one implementation. What stays here is the presentation: two
 * formatters that only a screen needs.
 */

export { RecordingUploader, UploadAborted, blobSource } from "@rp/studio-client";
export type {
  UploadBody, UploadPart, UploadProgress, UploadSource, UploaderOptions,
} from "@rp/studio-client";

export function formatBytes(n: number): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v < 10 && i > 0 ? v.toFixed(1) : Math.round(v)} ${units[i]}`;
}

export function formatDuration(seconds: number | null): string {
  if (seconds === null || !Number.isFinite(seconds)) return "—";
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  return `${Math.floor(seconds / 3600)}h ${Math.round((seconds % 3600) / 60)}m`;
}
